<div class="flex flex-col gap-8 p-8">
  <div>
    <div class="text-amber-700 mb-2 text-lg">
      {{ 'method using @let and async pipe on observable' }}
    </div>
    @let user = user$ | async;

    @if (user) {
      <h1>Hello, {{ user.name }}</h1>
      <ul>
        @for (snack of user.favoriteSnacks; track snack) {
          <li>{{ snack.name }}</li>
        }
      </ul>
      <button (click)="update(user)">Update profile</button>
    }
  </div>

  <div>
    <div class="text-amber-700 mb-2 text-lg">
      {{ 'method using ngrx store and async pipe on observable' }}
    </div>
    <div *ngIf="users$ | async as user">
      <h1>User Information</h1>
      <img *ngIf="user?.avatar" [src]="user?.avatar" alt="{{ user.fullname }}" width="100" />
      <p>ID: {{ user?.id }}</p>
      <p>Name: {{ user?.fullname }}</p>
      <p>Email: {{ user?.email }}</p>
      <p *ngIf="user?.status">Status: {{ user?.status }}</p>
      <button mat-flat-button class="bg-slate-500 mt-2" (click)="goToProducts()">
        Go to products
      </button>
    </div>
  </div>
</div>
